import {
    AccountModel,
    EEditorType,
    EPopupPosition,
    ListModel,
    TBrand,
    UserModel
} from "@cakemail-org/ui-components-v2"

export type TBeeEditor = {
    cssFileName?: EEditorCssFileName,
    variant?: "modal" | "inline"
    hidden?: boolean,
    className?: string,
    titleContent?: any,
    editorType: EEditorType,
    contentContext?: TBeeEditorContentContext,
    containerName?: string,
    initContent?: any,
    onBrandingToggle?: () => Promise<any>,

    onSave?: (jsonFile: string, htmlFile: string) => Promise<void>,
    onChange?: (jsonFile: string, response: any) => void,
    onSaveAsTemplate?: (jsonFile: string) => void,
    onAutoSave?: (jsonFile: string) => void,
    onSend?: (htmlFile: string) => void,
    onLoad?: (jsonFile: string) => void,
    onError?: (errorMessage: string) => void,
    onWarning?: (alertMessage: string) => void,

    //Only usable on file manager
    onFilePickerInsert?: (data: any) => void,
    onFilePickerCancel?: () => void
} & (
        //if hidden is provided, onClose is required otherwise it will throw a type error
        | { hidden: true | false; onClose: () => void }
        | { hidden?: undefined; onClose?: undefined }
    )

export type TBeeEditorContentContext = {
    isSmart?: boolean,
    list?: ListModel,
    formAction?: string,
    popupPosition?: EPopupPosition,
    recaptchaSiteKey?: string,
}

export type TGetInitialBeeConfiguration = {
    reload?: boolean,
    cssFileName?: EEditorCssFileName,
    getContentContext: () => TBeeEditorContentContext,
    account: AccountModel
    user: UserModel
    partnerBrand: TBrand
    userBrand?: TBrand
    editorType: EEditorType,
    containerName: string,
    getLocalContent: () => any,
    onSave?: (jsonFile: string, htmlFile: string) => void,
    onChange?: (jsonFile: string, response: any) => void,
    onSaveAsTemplate?: (jsonFile: string) => void,
    onAutoSave?: (jsonFile: string) => void,
    onSend?: (htmlFile: string) => void,
    onLoad?: (jsonFile: string) => void,
    onError?: (errorMessage: string) => void,
    onWarning?: (alertMessage: string) => void,
    onFilePickerInsert?: (data: any) => void,
    onFilePickerCancel?: () => void
}

export enum EEditorCacheKeys {
    listAttributes = "editorListAttributesCache",
    listInterests = "editorListInterestsCache",
    tags = "editorTagsCache",
}

export type TFileManagerFile = {
    name: string,
    path: string,
    "last-modified": string,
    permissions: string,
    extra: any,
    "mime-type": string,
    size: number,
    "public-url": string,
    thumbnail: string,
    "is-selectable": boolean,
    selected: boolean,
    type: string,
    isFile: boolean
}

export enum EEditorCssFileName {
    bee = "bee",
    fileManager = "fileManager",
    fileManagerOverlay = "fileManagerOverlay",
}